app.factory("cart", [
  "$rootScope",
  "LocalStorageFactory",
  "ContentFactory",
  "$q",
  "$location",
  function ($rootScope, LocalStorageFactory, ContentFactory, $q, $location) {
    function addItemToCart(cart, cartobj) {
      cart.push(cartobj);
      updateCart(cart);
    }

    function updateCart(cart) {
      LocalStorageFactory.update("cart", cart);
      $rootScope.cart = cart;
      $rootScope.cartNumber = cart.length;
    }

    function isContentAlreadyOwned(customerId, contentId) {
      let q = $q.defer();
      ContentFactory.getCustomerTickets(customerId).then(function (tickets) {
        q.resolve(ContentFactory.checkTicketsForContentId(tickets, contentId));
      });
      return q.promise;
    }

    return {
      addToCart: function (cartobj, redirectUrl) {
        const microsite = LocalStorageFactory.getByKey("microsite");
        const siteConfig = microsite.microsite;

        let cart = LocalStorageFactory.getByKey("cart") || [];
        let contentId = cartobj.contentID;
        let customerId = LocalStorageFactory.getByKey("shopUserID");
        if (customerId != undefined) {
          var alreadyOwned = isContentAlreadyOwned(customerId, contentId);
        } else {
          var alreadyOwned = $q.when(false);
        }

        var pos = cart
          .map(function (e) {
            return e.contentID;
          })
          .indexOf(contentId);

        alreadyOwned.then(function (owned) {
          if (owned) {
            if (siteConfig.enableMultiPurchase == 1) {
              addItemToCart(cart, cartobj);
              if (redirectUrl) {
                $location.path(redirectUrl);
              }
              toastr.warning("You've already bought this item");
            } else {
              toastr.error("You've already bought this item");
            }
          } else {
            if (pos !== -1) {
              if (siteConfig.enableMultiPurchase == 1) {
                addItemToCart(cart, cartobj);

                if (redirectUrl) {
                  $location.path(redirectUrl);
                }
                toastr.warning("Item added to your cart - again");
              } else {
                toastr.error("Item is already in your cart");
              }
            } else {
              addItemToCart(cart, cartobj);

              if (redirectUrl) {
                $location.path(redirectUrl);
              }
              toastr.success("Item added to your cart");
            }
          }
        });
      },
      removeFromCart: function (contentID, scope) {
        var cart = LocalStorageFactory.getByKey("cart");
        var pos = cart
          .map(function (e) {
            return e.contentID;
          })
          .indexOf(contentID);

        if (pos !== -1) {
          cart.splice(pos, 1); //remove
        }

        updateCart(cart);
      },
      getCartQty: function () {
        var ret = { qty: 0, total: 0 };
        let cart = LocalStorageFactory.getByKey("cart") || [];

        ret.qty = cart.length;
        for (let i = 0; i < cart.length; i++) {
          ret.total += parseFloat(cart[i].price);
        }

        var totalAmount = roundTo(ret.total, 2).toFixed(2);
        ret.total = totalAmount;
        return ret;
      },
      removeAlreadyOwnedContentFromCart: function () {
        let cart = LocalStorageFactory.getByKey("cart");
        if (cart == undefined) {
          return;
        }
        const microsite = LocalStorageFactory.getByKey("microsite");
        const siteConfig = microsite.microsite;
        let customerId = LocalStorageFactory.getByKey("shopUserID");

        ContentFactory.getCustomerTickets(customerId).then(function (tickets) {
          let removedItemFromCart = false;
          // iterate through the array in reverse so if content is removed it won't change the index of the remaining cart items
          for (let i = cart.length - 1; i >= 0; i--) {
            if (
              ContentFactory.checkTicketsForContentId(
                tickets,
                cart[i].contentID
              )
            ) {
              if (siteConfig.enableMultiPurchase == 0) {
                cart.splice(i, 1);
              }
              removedItemFromCart = true;
            }
          }
          updateCart(cart);
          if (removedItemFromCart) {
            if (siteConfig.enableMultiPurchase == 0) {
              toastr.warning(
                "Removed items from your cart that you already own"
              );
            } else {
              toastr.warning(
                "You have items in your cart that you already own"
              );
            }
          }
        });
      },
    };
  },
]);
